import {RepositoryFactory} from "../../scripts/RepositoryFactory";

const UserRepository = RepositoryFactory.get('users');

const state = {
    users: [],
    showUserError: false,
    userExists: false,
    currentUser: null,
    loadingUser: false,
};

// actions
const actions = {
    async fetch({commit}) {
        const {data} = await UserRepository.get();
        commit('setData', {data: data});
    },
};

// mutations
const mutations = {
    setData(state, {data}) {
        state.users = data;
    },
    showUserError(state, {data}) {
        state.showUserError = data;
    },
    userExists(state, {data}) {
        state.userExists = data;
    },
    setCurrentUser(state, data) {
        state.currentUser = data;
    },
    setLoading(state, data) {
        state.loadingUser = data;
    }
};


export default {
    namespaced: true,
    state,
    actions,
    mutations
}